import { createImageApi } from './imageApi';
const api = createImageApi('ux-panel-images', 'UX panel');
export function uploadUxPanelImage(data) {
    return api.upload(data);
}
export function getUxPanelImages(levelId) {
    return api.list(levelId);
}
export function getArchivedUxPanelImages(levelId) {
    return api.listArchived(levelId);
}
export function archiveUxPanelImage(id) {
    return api.archive(id);
}
export function restoreUxPanelImage(id) {
    return api.restore(id);
}
export function deleteUxPanelImagePermanent(id) {
    return api.deletePermanent(id);
}
